<script>
import apigeneric from "@/helpers/apigeneric";
import VueHorizontal from 'vue-horizontal';
export default {
  mixins: [apigeneric],
  data() {
    return {
      LinksData: {},
      LinksTitle: {}
    };
  },
  components: {
    VueHorizontal
  },
  methods: {
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({
        Service: "Links",
        Page: Page,
        Filter: "&Linkcategory=2&Websiteid=" + window.$cookies.get("ecampuswebsite"),
      }).then((res) => {
        this.LinksData = res.Data;
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.localStorage.getItem("lang")
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=064893e0-7e31-4c14-879c-426ce9471fa1"
          }).then((res) => {
            this.LinksTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    }
  },
};
</script>

<template>
  <section style=" margin-bottom:-100px">
    <div class="social-media">
      <div class="title c-flex"> 
        <h4>{{ $t("dashboards.ImageLinksTitle") }}</h4>
      </div>
      <div class="line">
      </div>
      <div class="row mt-3 px-5">
        <vue-horizontal v-if="LinksData.length > 0" responsive>
          <section v-for="(Data, index) in LinksData" :key="index">
                  <div class="card  px-2 py-2" style="width: 15rem;">
                  <a :href="Data.Url" class="card-link" :target="Data.Target">
                    <img class="full-width" style="height: 100px;" :src="$config.FILES_URL + 'web/' + Data.Imageurl" alt="Logo" />
                  </a>
                </div>
                </section>
        </vue-horizontal>
      </div>

      <div class="line">

      </div>
    </div>
  </section>
</template>
<style scoped>
section,
.item {
  background: #f3f3f3;
  padding: 16px 24px;
  margin-right: 24px;
}
</style>
